if (!customElements.get('collection-load-previous')) {
  class CollectionLoadPrevious extends HTMLElement {
    constructor() {
      super();

      this.btnLoadPrevious = this.querySelector('.js-btn-load-previous');
      this.productGrid = document.querySelector('#product-grid');

      this.setProperties();

      this.btnLoadPrevious.addEventListener('click', e => {
        e.preventDefault();

        this.btnLoadPrevious.setAttribute('disabled', true);

        this.loadPreviousProducts();
      });
      this.checkPageParameter();
    }

    checkPageParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const page = urlParams.get('page') || '1';
      const previousButton = document.querySelector("collection-load-previous");

      if (page === '1' && previousButton) {
        previousButton.style.display = 'none';
      }
    }

    setProperties() {
      this.productGrid = document.querySelector('#product-grid');
      this.btnLoadPrevious = this.querySelector('.js-btn-load-previous');
    }

    async loadPreviousProducts() {
      try {
        const productGridContainer = document.querySelector('#ProductGridContainer');
        const isMixed =
          productGridContainer &&
          (productGridContainer.getAttribute('data-mixed-product-collection') ===
            'true' ||
            productGridContainer.getAttribute('data-mixed-product-collection') ===
              '1');

        if (isMixed && window.CollectionVendorMix?.handleLoadPrevious) {
          const handled = await window.CollectionVendorMix.handleLoadPrevious(document);
          if (handled) {
            this.checkPageParameter();
            return;
          }
        }

        const prevPageResponse = await fetch(`${this.btnLoadPrevious.dataset.href}`);
        const prevPageText = await prevPageResponse.text();

        const prevPageHTML = new DOMParser().parseFromString(prevPageText, 'text/html');

        const prevProductGridContainer = prevPageHTML.querySelector('#ProductGridContainer');
        const productGrid = prevProductGridContainer.querySelector('#product-grid');

        this.productGrid.insertAdjacentHTML('afterbegin', productGrid.innerHTML);

        document.dispatchEvent(new CustomEvent('collection:grid-updated', { bubbles: true, detail: { source: 'load-previous' } }));


        const prevButtonOnNewPage = prevPageHTML.querySelector('.js-btn-load-previous');
        if (prevButtonOnNewPage) {
          const prevPageLink = prevButtonOnNewPage.dataset.href;
          this.btnLoadPrevious.dataset.href = prevPageLink;
        }

        const currentUrl = new URL(window.location.href);
        const currentUrlParams = new URLSearchParams(currentUrl.search);
        const currentPage = parseInt(currentUrlParams.get('page'), 10) || 1;

        const nextPage = Math.max(1, currentPage - 1);
        if (nextPage <= 1) {
          currentUrlParams.delete('page');
        } else {
          currentUrlParams.set('page', String(nextPage));
        }
        currentUrl.search = currentUrlParams.toString();

        history.replaceState({}, '', currentUrl.toString());

        this.checkPageParameter();
      } catch (error) {
        console.error(error);
        alert(error.message);
      } finally {
        this.btnLoadPrevious.removeAttribute('disabled');
      }
    }
  }

  customElements.define('collection-load-previous', CollectionLoadPrevious);
}
